import { ROOT } from "../../../../constants/componentType";

class TreeResults {
  constructor() {
    this.results = new Map(); // treeId - componentId - data
    this.whatIfResults = new Map();
  }

  initTreeResult = (treeId, branch, rawResults) => {
    const result = new Map(), whatIfResult = new Map();
    if (branch.length < 2) {
      this.results.set(treeId, result);
      this.whatIfResults.set(treeId, whatIfResult);
      return;
    }
    const { results, spiceResults } = rawResults;
    const components = branch.flat();
    const componentMap = new Map();
    components.forEach(comp => {
      comp.ids.forEach(id => componentMap.set(id, comp));
    });
    const processResults = (resultMap, resultData) => {
      for (let column of branch) {
        for (let comp of column) {
          const { pcbKey, pins, name, prev = [], next = [], id } = comp;
          const pcbResult = resultData.find(r => r.pcbKey === pcbKey);
          if (!pcbResult || !pcbResult.results) {
            continue;
          }
          const { results: { leafNodePassResults = [], pinPairResResults = [], pinVoltageResults = [], loadTotalResResults = [] } } = pcbResult;
          const prevNets = prev.map(p => p.prevNet);
          const prevNetsSet = new Set(prevNets);
          const nextNets = next.map(n => n.nextNet);
          const allNetsSet = new Set([...prevNets, ...nextNets]);
          const pinsSet = new Set(pins.map(pin => pin.pin));
          const prevComps = prev.map(p => {
            const prevNet = p.prevNet;
            return p.prevComps
              .map(id => {
                const component = componentMap.get(id);
                if (!component) return null;
                const componentPins = component.pins.filter(pin => pin.net === prevNet);
                if (componentPins.length === 0) return null;
                return { compName: component.name, pins: componentPins, pinSet: new Set(componentPins.map(pin => pin.pin)) };
              })
              .filter(Boolean);
          }).flat();
          const pass = leafNodePassResults.find(item => item.id === treeId && item.componentName === name && prevNetsSet.has(item.prevNetName));
          const pairRes = pinPairResResults.filter(item => {
            if (item.componentIn !== name || !pinsSet.has(item.pinIn)) return false;
            return prevComps.some(p => p.compName === item.componentOut && p.pinSet.has(item.pinOut));
          });
          const voltage = pinVoltageResults.filter(item => {
            return item.component === name && allNetsSet.has(item.net) && pinsSet.has(item.pin);
          });
          const totalRes = loadTotalResResults.find(item => item.loadName === name && prevNetsSet.has(item.loadPrevNet));
          resultMap.set(id, { pass, pairRes, voltage, totalRes });
        }
      }
    };
    if (results) processResults(result, results);
    if (spiceResults) processResults(whatIfResult, spiceResults);
    this.results.set(treeId, result);
    this.whatIfResults.set(treeId, whatIfResult);
  }

  getTreeResult = (treeId, id) => {
    const result = this.results.get(treeId)
    return result ? result.get(id) : null;
  }

  getSpiceResult = (treeId, id) => {
    const result = this.whatIfResults.get(treeId)
    return result ? result.get(id) : null;
  }

  clearResult = (treeId) => {
    this.results.set(treeId, new Map());
    this.whatIfResults.set(treeId, new Map());
  }
}

const treeResults = new TreeResults();
export default treeResults;